"use client";

import { PageLoadingStateV2 } from "components/ui/v2/maintainer/page-loading-state-v2";

export interface CertificatesLoadingStateV2Props {
  title: string;
  description: string;
}

export function CertificatesLoadingStateV2({
  title,
  description,
}: CertificatesLoadingStateV2Props) {
  return <PageLoadingStateV2 embedded title={title} description={description} />;
}
